import * as React from 'react';

import * as styles from './InsideIcon.css';

export const InsideIcon: React.FC = () => <div className={styles['icon']} />;
